module.exports = __webpack_public_path__ + "img/people.0a674f60.png";